(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('culina-slide-link')) {
    customElements.define('culina-slide-link', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        const link = this.querySelector('a');
        const slide = this.closest('slideshow-slide');
        if (!link || !slide) return;
        const slideshow = slide.closest('slideshow-component');
        const controller = new AbortController();
        this.controller = controller;
        const options = { capture: true, signal: controller.signal };
        let gesture = null;
        const syncFocus = () => {
          link.tabIndex = slide.getAttribute('aria-hidden') === 'true' || slide.hidden ? -1 : 0;
        };
        syncFocus();
        this.observer = new MutationObserver(syncFocus);
        this.observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden', 'hidden'] });
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) { gesture = null; return; }
          gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, moved: !event.isPrimary };
        }, options);
        const track = (event) => {
          if (!gesture || gesture.id !== event.pointerId) return;
          if (Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 6) gesture.moved = true;
        };
        document.addEventListener('pointermove', track, options);
        document.addEventListener('pointerup', track, options);
        document.addEventListener('pointercancel', (event) => {
          if (gesture?.id === event.pointerId) gesture.moved = true;
        }, options);
        link.addEventListener('dragstart', (event) => event.preventDefault(), { signal: controller.signal });
        link.addEventListener('click', (event) => {
          event.stopPropagation();
          const editor = window.Shopify?.designMode;
          const moving = slideshow?.hasAttribute('dragging') || slideshow?.hasAttribute('transitioning');
          if (editor || slide.getAttribute('aria-hidden') === 'true' ||
              (event.detail !== 0 && (gesture?.moved || moving))) event.preventDefault();
          gesture = null;
        }, { capture: true, signal: controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
